import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Autocomplete } from '@mui/material';
import { useSelector, useDispatch } from "react-redux";
import { taskCompanyRequest } from "../store/actions/task.js"; // Assuming you're using react-select
import Api from "../Api.js";
import Loader from "./BlueButton/Loader.js";
import CheckboxFilter from "./CheckboxFilter.js";
import { REACT_APP_API_URL } from '../config.js';
import moment from "moment";

import 'moment/locale/hy-am.js'; // Import locale if needed
import EventDropTask from './Mydata/EventDropTask.js';
export default function EventModal({ open, setData, handleClose, handleEditSave, handleSave, date, data }) {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [type, setType] = useState('');
    const [templateId, setTemplateId] = useState(0);
    const [startTime, setStartTime] = useState('10:00');
    const [endTime, setEndTime] = useState('11:00');
    const [forMe, setForMe] = useState(false);
    const login = useSelector((state) => state.manager.employee);
    const [images, setImages] = useState([]);
    const deletePhoto = (item,) => {
        setImages((prevImages) => prevImages.filter((el) => el.name !== item.name));
    };
    const handleFileChange = (e) => {
        let newFiles = Array.from(e.target.files);
        setImages((prevImages) => [...prevImages, ...newFiles]);
    };
    const [taskForm, setTaskForm] = useState({
        company: [],
        manager: "",
        accountant: localStorage.getItem('profession') === "accountant" ? [{
            value: login.id,
            label: login.user.first_name + ' ' + login.user.last_name
        }] : "",
        visibleForClient: false
    });
    const ADMIN_IDS = [2, 86, 1024,1918];
    const account = useSelector((state) => state.task.accountant);
    const companies = useSelector((state) => state.task.companies);
    const managers = useSelector((state) => state.task.managers);
    const dispatch = useDispatch()

    const [limitData, setLimitData] = useState({
        organization: [],
        taskTemplate: [],
        manager: [],
        stuff: [],

    });
    useEffect(() => {
        (async () => {
            await dispatch(taskCompanyRequest())
        })();
    }, []);
    const isAdmin = ADMIN_IDS.includes(login.user_id);
    const handletask = async () => {
        let createdDate = new Date().toLocaleString("en-US", { timeZone: "Asia/Yerevan" });
        const endDateTime = `${date}T${startTime}:00`;
        let formData = new FormData();
        let creator = login.user.url;
        let multiAccountant = forMe ? [] : taskForm.accountant;
        let taskList = []
        formData.append("created_date", moment(createdDate).format("YYYY-MM-DD HH:mm:ss"));
        formData.append("creator", creator);
        formData.append("accountant", taskForm.accountant);
        formData.append("template_id", templateId);
        formData.append("company", taskForm.company);
        formData.append("text", description);
        formData.append("name", title);
        formData.append("visible_for_client", taskForm.visibleForClient);
        formData.append("end_date", moment(endDateTime).format("YYYY-MM-DD HH:mm:ss"));
        formData.append("manager", taskForm.manager || login.url);
        images.forEach((image, index) => {
            formData.append(`file${index + 1}`, image, image.name);
        });
        if (multiAccountant.length > 0) {
            for (const accountant of multiAccountant) {
                formData.append("accountant", `${REACT_APP_API_URL}accountant/${accountant.value}/`);
                let d = await Api.createTask(formData);
                taskList.push(d.data.id)
            }
        } else {
            let d = await Api.createTask(formData);
            taskList.push(d.data.id)
        }

        return taskList
    }
    const [status, setStatus] = useState('pending');
    const onSubmit = async () => {
        const startDateTime = `${date}T${startTime}:00`; // Combine date and time
        const endDateTime = `${date}T${endTime}:00`; // Combine date and time
        if (data) {
            handleEditSave({
                title,
                dayoff: data._def.extendedProps.dayoff,
                description,
                start: startDateTime, // sends with timezone offset
                end: endDateTime,
                ...(isAdmin ? { status } : {})
            }, data._def.publicId);
        } else {
            if (type === "task") {
                let taskList = await handletask()

                for (const element of taskList) {
                    handleSave({
                        title,
                        description,
                        start: startDateTime, // sends with timezone offset
                        end: endDateTime,
                        task: element,
                        ...(isAdmin ? { status } : {})
                    });
                }

            } else {
                if (type === "dayoff") {
                    const formData = new FormData()
                    formData.append('title', title);
                    formData.append('text', description);
                    formData.append('end_date', endDateTime);
                    formData.append('start_date', startDateTime);
                    formData.append('creator', login.user_id);
                    formData.append('approved', 0);
                    formData.append('created_date', moment(new Date()).format("YYYY-MM-DDTHH:mm"));
                    await Api.addDayoff(formData)
                    handleSave({
                        title,
                        description,
                        start: startDateTime, // sends with timezone offset
                        end: endDateTime,
                        dayoff:true,
                        ...(isAdmin ? { status } : {})
                    });
                }else{
                    handleSave({
                        title,
                        description,
                        start: startDateTime, // sends with timezone offset
                        end: endDateTime,
                        ...(isAdmin ? { status } : {})
                    });
                }
               
            }




        }

        setData(null)
        setTitle('');
        setDescription('');
        setStartTime('10:00');
        setEndTime('11:00');
        handleClose()
    };
    useEffect(() => {
        (async () => {
            const template = await Api.taskTemplate()
            setLimitData({
                organization: companies.map(s => ({ ...s, url: REACT_APP_API_URL + 'manager-company/' + s.id + '/' })),
                taskTemplate: template.data.results,
                manager: managers,
                stuff: account.map(s => ({ value: s.id, label: s.user.first_name + ' ' + s.user.last_name }))
            })
        })()
    }, [account, managers, companies])

    useEffect(() => {
        (async () => {
            if (data) {

                let form = data?._def
                let date1 = data?._instance?.range
                if (form.extendedProps.task) {
                    const { data } = await Api.getTaskSingle(form.extendedProps.task)
                    const parts = data?.accountant?.split("/").filter(Boolean); // split and remove empty strings
                    const id = parts ? parts[parts?.length - 1] : "";
                    setTaskForm({
                        company: data.company,
                        manager: data.manager,
                        accountant: id ? { value: +id, label: `${account.find(s => s.id === +id)?.user?.first_name} ${account.find(s => s.id === +id)?.user?.last_name}` } : null,
                        visibleForClient: data.visible_for_client
                    })

                }
                setTitle(form?.title);
                setDescription(form?.extendedProps?.description);
                setStatus(form?.extendedProps?.status);
                setStartTime(date1?.start?.toISOString().split("T")[1].split(".")[0].slice(0, -3))
                setEndTime(date1?.end?.toISOString().split("T")[1].split(".")[0].slice(0, -3))
                setType(form.extendedProps.task ? "task" : form.extendedProps.dayoff ? "dayoff" : "")
            }
        })()

        // setEndTime(form.extendedProps.description);
    }, [data, account])

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{!data ? "Ստեղծել" : "Փոփոխել"} ժամանակացույց</DialogTitle>

            <DialogContent>
                <TextField
                    select
                    fullWidth
                    margin="dense"
                    disabled={data}
                    SelectProps={{ native: true }}
                    value={type}
                    onChange={e => setType(e.target.value)}
                >
                    <option value="">Պարզապես օրացույց</option>
                    <option value="task">Առաջադրանք</option>
                    <option value="dayoff">Day-off</option>
                </TextField>

                {type === "task" ? <Autocomplete
                    style={{ margin: "10px 0" }}

                    loading={limitData.taskTemplate.length <= 0}
                    loadingText={<div className="auto-complete-loader"><Loader size={15} /></div>}
                    id="combo-box-demo"
                    options={limitData.taskTemplate}
                    onChange={(e, value) => {
                        setTemplateId(value.id)
                        setTitle(value.name)
                    }}
                    getOptionLabel={option => {
                        return option.name
                    }}
                    renderInput={params => (
                        <TextField
                            {...params}
                            label="Ընտրել առաջադրանքի վերնագիր"
                            variant="outlined" fullWidth
                        />
                    )}
                /> : null}

                <TextField
                    style={{ margin: "10px 0" }}

                    autoFocus
                    label="Վերնագիր"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                />
                <TextField
                    style={{ margin: "10px 0" }}
                    label="Նկարագրություն"
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    margin="dense"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                />
                {type === "task" && <EventDropTask
                    forMe={forMe} options={limitData.organization} item={{ key: 'company', value: taskForm.company }} setFormData={setTaskForm} setForMe={setForMe}
                />}
                {type === "task" && <EventDropTask
                    forMe={forMe} options={limitData.manager} item={{ key: 'manager', value: taskForm.manager }} setFormData={setTaskForm} setForMe={setForMe}
                />}
                {type === "task" && <EventDropTask
                    forMe={forMe} options={limitData.stuff} item={{ key: 'accountant', value: taskForm.accountant }} setFormData={setTaskForm} setForMe={setForMe}
                />}

                <TextField
                    label="Սկիզբ"
                    type="time"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={startTime}
                    onChange={e => setStartTime(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        step: 300, // 5 min steps
                    }}
                />
                {type !== "task" && <TextField
                    label="Վերջ"
                    type="time"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={endTime}
                    onChange={e => setEndTime(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        step: 300, // 5 min steps
                    }}
                />}
                {type === "task" && <CheckboxFilter title="Տեսանելի բոլորի համար"
                    my_task={taskForm.visibleForClient}
                    onChange={() => {
                        setTaskForm(prev => ({ ...prev, visibleForClient: !prev.visibleForClient }))
                    }} />}
                {type === "task" && (<div className='img-icon-cont'>
                    <div className='img-cont'>
                        {images.map((item, index) => {
                            return <div className='img' key={index}>
                                <span
                                    className={(item.type === "image/jpeg") || (item.type === "image/png") ? 'icon-Photos' : "icon-files-empty"} />
                                <span className='images-name'>{item.name}</span>
                                <i className="fas fa-times" onClick={() => deletePhoto(item)} />
                            </div>
                        })}
                    </div>
                    <label>
                        <span className='icon-Attachment' />
                        <input type="file" multiple className='input-icon'
                            onChange={(e) => handleFileChange(e)} />
                    </label>

                </div>)
                }
                {type === "task" && <div className='line-blue' />}
                {isAdmin && data?._def?.extendedProps?.dayoff && (
                    <TextField
                        label="Կարգավիճակ"
                        select
                        fullWidth
                        margin="dense"
                        SelectProps={{ native: true }}
                        value={status}
                        onChange={e => setStatus(e.target.value)}
                    >
                        <option value="pending">Սպասում</option>
                        <option value="approved">Հաստատված</option>
                        <option value="rejected">Մերժված</option>
                    </TextField>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Չեղարկել</Button>
                <Button variant="contained" onClick={onSubmit} disabled={!title}>
                    Պահպանել
                </Button>
            </DialogActions>
        </Dialog>
    );
}
